<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">



        <div 
            class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
            <div
                class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Update Package</h6>
                </div>

            </div>
            <!-- Start All Language List Table -->
            <div class="p-3 sm:p-4">
                <div class="flex flex-wrap gap-4 overflow-x-auto scrollbar-table">
                    <div class="bg-white dark:bg-dark-bg rounded-lg shadow-md overflow-hidden w-72"
                        v-for="(item, index) in packageList" :key="item.id">
                        <div :class="item.id==package_here.packageid? 'sele_card p-4':'p-4'">
                            <h3 class="font-semibold text-lg text-gray-700 dark:text-dark-text">{{ item.name }}</h3>
                            <p class="text-gray-500 dark:text-dark-secondary">Rate: {{ item.cost }}</p>
                            <p class="text-gray-500 dark:text-dark-secondary">Days : {{ item.days }}</p>
                            <p class="text-gray-500 dark:text-dark-secondary">description: {{ item.description }}</p>
                            <!-- <p class="text-gray-500 dark:text-dark-secondary">Status: {{ item.status }}</p> -->
                        </div>
                        <div class="flex justify-center p-4 border-t border-gray-200 dark:border-dark-border">
                            <button class="btn-select" @click="select_this_Package(item)">
                                Select
                            </button>
                        </div>
                    </div>
                </div>
            </div>



            <!-- start -->


            <div mt-2>
                <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label ml-3">Start Date *</label>
                        <input type="date" v-model="package_here.startdate" placeholder="Type Here"
                            class="form-input ml-4" required autocomplete="off">
                    </div>


                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label ml-4">Total *</label>
                        <input type="number" v-model="package_here.total" readonly="" placeholder="Type Here"
                            class="form-input  ml-3" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label ml-3">Paid *</label>
                        <input type="number" v-model="package_here.paid" placeholder="Type Here"
                            class="form-input ml-3" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none ml-3">
                        <label class="form-label">Payment Type *</label>
                        <select class="form-input" v-model="package_here.paymenttype">
                            <option disabled value="0">SELECT Payment Type</option>
                            <option value="Cash">Cash</option>
                            <option value="Upi">Upi</option>
                            <!-- <option v-for="(item, index) in packageList" :value="item.id">{{ item.name }}</option> -->
                        </select>
                    </div>


                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label ml-3">Note *</label>
                        <input type="text" v-model="package_here.note" placeholder="Type Here"
                            class="form-input ml-3" required autocomplete="off">
                    </div>


                </div>

            </div>

            <!-- end  -->










            <!-- <button @click="SelectPackage" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6 ml-3">
                <i class="fa fa-left-arrow"></i> Go Back
            </button> -->


            <button @click="save" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6 ml-3">
                <i class="fa fa-left-arrow"></i> Save
            </button>


            <!-- End All Language List Table -->
        </div>

    </div>



</template>
<style scoped>
    .sele_card {
        background: #f9bb6f;
    }
</style>

<script>
    // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'
    import axios from 'axios';

    export default {
        name: 'AddProduct',
        components: {

        },

        mounted() {
            this.getBasics();

        },

        data() {
            return {
                isMember: true,
                isAdd: 0,
                isEdit: 0,
                isDelete: 0,
                deleteId: 0,
                packageList: [],
                // customer: { name: '', cat: '0', barcode: '', hsn: '', descr: '', gst: '5', unit: '', mrp: '0', prate: '0', salerate: '0', set_rate: '0', set_qty: '0', op_qty: 0 },
                // employees: { empname: '', emprole: '0', isMainAdmin: 0 },



                package_here: {
                    startdate: new Date().toISOString().split('T')[0],
                    total: '',
                    paid: '',
                    note: '',
                    memberid: '',
                    paymenttype: '',
                    packageid: '',

                },


                // customer: { 

                //     memberid: '',
                //     firstname: '',
                //     lastname:'',
                //     date: '',
                //     gender: '',
                //     address: '',
                //     city: '',
                //     state: '',
                //     phonenumber: '',
                //     email: '',
                //     emergency: '',           
                // },



            }

        },

        methods: {

            updatePackageMemberId() {
                this.package_here.memberid = this.customer.memberid;
            },

            SelectPackage() {
                this.isMember = !this.isMember;
            },
            select_this_Package(item) {
                this.package_here.packageid = item.id;
                this.package_here.total = item.cost; // Set the total to the package cost
            },

            async getBasics() {
                const memberid = this.$route.query.memberid;
                //this.package_here = { 'memberid': memberid }
                console.log(memberid);
                // const memberid=this.$route.params.id;
                var self = this;
                axios.post('getBasicForCustomer').then(function (response) {
                    self.packageList = response.data.packages;
                    self.employees = response.data.userDetails;
                    if(memberid){
                        self.package_here.memberid=memberid;
                    }
                });
            },
            nextFocus(e) {
                const inputs = Array.from(e.target.form.querySelectorAll('input'));
                const index = inputs.indexOf(e.target);

                if (index < inputs.length) {
                    try {
                        inputs[index + 1].focus();
                        inputs[index + 1].select();
                    } catch (error) {
                        $("#saveBtn").focus();
                    }
                }
            },
             navigateToPrintPage(memberId) {
                    const url = `${window.location.origin}/#/invoice/print?id=${memberId}`;
                    const newWindow = window.open(url, '_blank');
                    
                    // Ensure the new tab is opened before triggering print
                    if (newWindow) {
                      newWindow.focus();
                    } else {
                      alert("Popup blocked. Please allow popups for this site.");
                    }
                  },
            save() {
                var self = this;
                if (self.package_here.total == '')
                    self.$swal("Product Name is Required");
                else if (self.package_here.startdate == '') 
                    self.$swal("StartDate is Required"); 
                else {
                    self.$swal({
                        title: "Do You Want To Save?",
                        text: "Are you sure? ",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Yes"
                    }).then((result) => { // <--
                        if (result.value) { // <-- if confirmed
                            axios.post('updatepackage', { pkg: JSON.stringify(this.package_here) })
                                .then(response => {
                                    var msg = response.data.msg;
                                    var isSuccess = response.data.status;
                                    //self.packageList = response.data.cats;
                                    // self.employees = response.data.userDetails;
                                    // self.cat = { name: '', status: 'Active' };
                                    if (isSuccess == 1) {
                                        self.customer = { memberid: '', firstname: '', lastname: '', gender: '', address: '', city: '', state: '', phonenumber: '', email: '', emergency: '' };
                                        //  $("#barcode").focus();
                                        self.navigateToPrintPage(response.data.sub_id);

// invoice/print?id=
                                        //      // Now, perform another axios post for a package operation
                                        //      axios.post('packageaccount', this.package)
                                        //        .then(response => {
                                        //         var msg = response.data.msg;
                                        //         var isSuccess = response.data.status;

                                        //     if (packageSuccess == 1) {
                                        //         // console.log('Package added successfully');
                                        //         self.package = { startdate: '',  total: '',paid: '', note: '', address: '', note: '',memberid: '',packagetype: ''};
                                        //     } else {
                                        //         console.log('Failed to add package');
                                        //     }
                                        // })
                                        // .catch(packageError => {
                                        //     console.log('Error on Package operation: ' + packageError);
                                        // });






                                    }

                                    // Now, perform another axios post for a package operation




                                    self.$swal(msg);

                                })
                                .catch(error => {
                                    console.log('Error on Authentication: ' + error);
                                });
                        }
                    });
                }

            }
        }


        // end-----------------------------------------------------
    }
</script>